/**
 * FAQPage JSON-LD for posts whose body ends in a visible FAQ section.
 * Questions and answers must match the post body word for word.
 * Keyed by post slug. Posts without an entry get BlogPosting only.
 */
export const BLOG_FAQS = {
  'why-is-electricity-bill-so-high': [
    {
      question: 'Why has my electricity bill suddenly increased?',
      answer:
        'Possible reasons include increased AC usage, changes in appliance operation, a longer billing period, tariff changes or an electrical fault. Compare your consumption and billing details before deciding on the cause.',
    },
    {
      question: 'Does servicing an AC reduce electricity consumption?',
      answer:
        'Maintenance can help address problems such as restricted airflow or equipment faults. The actual effect depends on the condition of the unit and the underlying issue.',
    },
    {
      question: 'When should I contact an electrician?',
      answer:
        'Seek professional help for repeated breaker trips, burning smells, damaged wiring, unusual socket temperatures or unexplained electrical problems.',
    },
    {
      question: 'Where can I find electrical repair services in Kochi, Calicut or Trivandrum?',
      answer:
        'Visit Fixome.in to explore available electrical services and booking options in your service area.',
    },
  ],
};

export function blogFaqs(slug) {
  return BLOG_FAQS[slug] || null;
}
